<template>
 <div>


    <div id="appCapsule" class="pt-0">

    <form class="login" @submit.prevent="login">

    <div class="page-content">   
            
            <div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
            <div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
            <div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>
            
            <div class="page-title-small color-white bottom-30">
                <h1>Ingreso a Sistema Netcar PWA</h1>
            </div>   
            



          

 <form id="Formsubmit">
            <div class="cover-wrapper cover-no-buttons">           
                <div data-height="cover-title" class="round-medium bottom-0"  style="height:450px">
                    <div class="caption-center">

                        <div class="left-50 right-50">
                            <h1 class="color-white center-text uppercase ultrabold fa-2x top-40">INICIO DE SESIÓN</h1>
                            <p class="color-highlight center-text font-12 under-heading bottom-30 top-5">
                                Ingrese los datos de su cuenta
                                <span id="errorlogin" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold"></span>
                            </p>
                            
                          <span id="r_user" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Usuario requerido</span>
                            
                            <!-- <div class="input-style input-light has-icon input-style-1">
                                <i class="input-icon fas fa-building font-20"></i>
                                <span>Nombre empresa</span>
                                <input type="name" id="enterprise" v-model="enterprise" placeholder="Nombre empresa" class="round-small">
                            </div>  -->
                            <div class="input-style input-light has-icon input-style-1">
                                <i class="input-icon fa fa-user font-16"></i>
                                <span>Usuario</span>
                                <em>(requerido)</em>
                                <input type="name" id="user" v-model="user" placeholder="Usuario" class="round-small">
                            </div> 
							    <span id="r_password" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Clave requerida</span>
                            <div class="input-style input-light has-icon input-style-1 bottom-30">
                                <i class="input-icon fa fa-lock font-16"></i>
                                <span>Clave</span>
                                <em>(requerida)</em>
                                <input type="password" id="password" v-model="password" placeholder="Clave" class="round-small">
                            </div>          
                            <div class="clear"></div>
                            <a href="#" @click="login"  class="button bg-blue2-dark button-m button-full round-small bottom-10 shadow-small contactSubmitButton">INGRESAR</a>
                            <div class="divider top-30"></div>
                        </div>
                    </div>
                    <img src="./../../assets/images/pictures/29t.jpg" width="100%">
                    <div class="caption-overlay bg-black opacity-90"></div>
                </div>   
            </div>
 </form>            

          
        </div>
    
    </form>
    </div>


 </div>

</template>

<script>
//  import './../../assets/css/style.css'

//import './../../assets/js/lib/jquery-3.4.1.min.js'
//import './../../assets/js/lib/popper.min.js'
//import './../../assets/js/lib/bootstrap.min.js'

//  import './../../assets/scripts/jquery.js'
//  import './../../assets/scripts/plugins.js'
//  import './../../assets/scripts/custom.js'
import * as validate from "./../../validate.js";

export default {
    data(){
        return {
            user : "",
            password : "",
            enterprise: ""
        }
    },

    created() {
        this.$store.dispatch('logout')
        },

    methods: {


        login()
        {
            var strErr=validate.check(Formsubmit)
            if (strErr=="")
                {
                let enterprise = this.enterprise
                let user = this.user
                let password = this.password

                this.$store.dispatch('login', {enterprise:enterprise,user:user,password:password})
                .then((data) => {
                    if (data.data.err=="")
                        {
                        localStorage.setItem('user',JSON.stringify(data.data.user));
                        window.location="/dashboard"
                        }
                    else
                        {
                        document.getElementById("errorlogin").style.display='';
                        document.getElementById("errorlogin").innerHTML=data.data.err;
                        }
                    }
                ).catch(err => console.log(err.data))
                //alert(JSON.stringify(this.dataform))
                //localStorage.setItem('wizarddata1',JSON.stringify(this.dataform))
                //window.location="/Wizardot3characteristics"
                }

        }

    }
}
</script>